import {setupConsentPersistence} from './inMemoryConsentPersistence';

export function setup(consent) {
  setupConsentPersistence(consent);

  applyConsent();

  window.pageflowSourcepointConsentReady = function() {
    applyConsent();
  }

  const vendorIds = {
    'datawrapper': '5ec462c02330505ab89fbb37',
    'facebook': '5e7e1298b8e05c54a85c52d2',
    'google_tag_manager': '5e952f6107d9d20c88e7c975',
    'google_analytics4': '5e542b3a4cd8884eb41b5a72',
    'twitter': '5e71760b69966540e4554f01',
    'vimeo': '5eac148d4bfee33e7280d13b',
    'youtube': '5e7ac3fae30e7d1bc1ebf5e8'
  };

  function applyConsent() {
    if (!window.__tcfapi) {
      return;
    }
    window.__tcfapi('getCustomVendorConsents', 2, (vendorConsents) => {
      const grants = vendorConsents?.grants || {};
      consent.requested().then(({vendors}) => {
        console.log(vendors)
        vendors.forEach(vendor => {
          if (grants[vendorIds[vendor.name]]?.vendorGrant) {
            console.log('accept', vendor.name);
            consent.accept(vendor.name);
          }
          else {
            console.log('deny', vendor.name);
            consent.deny(vendor.name);
          }
        });
      });
    });
  }
}
